<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Tags List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Tags Table</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="filter-user">
        <button type="button"
                class="el-button el-button--primary"
                @click="goToAddTag">
          <span>Add new</span>
        </button>
      </div>
      <el-input
          v-model="searchQuery"
          placeholder="Search by name"
          style="margin-bottom: 20px; width: 300px;"
      ></el-input>
    </div>

    <el-table
        ref="indexingTable"
        :data="filteredTags"
        style="width: 100%;"
    >
      <el-table-column label="#" type="index"></el-table-column>

      <el-table-column prop="name" label="Name">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column prop="slug" label="Slug">
        <template slot-scope="scope">
          {{ scope.row.slug }}
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteTags(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderSortTitle from "../../../../components/UsersList/HeaderSortTitle.vue";

export default {
  name: 'IndexingPages',
  components: {HeaderSortTitle},
  data () {
    return {
      searchQuery: '',
    }
  },
  computed: {
    ...mapGetters({
      tags: 'tags/getTags',
    }),
    filteredTags() {
      return this.tags.filter(tag =>
          tag.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  created () {
    this.$store.dispatch('tags/getTags')
  },
  mounted () {
    this.getTags();
  },
  methods: {
    ...mapActions('tags', ['getTags']),
    deleteTags(tag) {
      this.$store.dispatch('tags/deleteTag', tag.id)
    },
    handleEdit(row) {
      this.$router.push({name: 'tag-edit', params: {id: row.id}})
    },
    goToAddTag(){
      this.$router.push({name: 'tag-create'})
    }
  }
}
</script>